// extracted by mini-css-extract-plugin
module.exports = {"article":"ItemQuantityBox-article-bi90f","green":"ItemQuantityBox-green-juazs","itemQtyLabel":"ItemQuantityBox-itemQtyLabel-okB7y","itemQty":"ItemQuantityBox-itemQty-gw23P"};